import * as PIXI from 'pixi.js';
import { ParentMixin } from '../core/parentMixin';
import { UpdateFlowMixin } from '../core/updateFlowMixin';
import { SerializableMixin } from '../core/serializableMixin';
import {
    AlphaAttribute,
    ColorAttribute,
    getAttributesToSerialize,
    NumberAttribute,
    StringOrNumberAttribute
} from '../core/attributes';
import { Config } from '../video-data/config';

export class DynamicBoxBorderConfigurator extends UpdateFlowMixin(ParentMixin(SerializableMixin(PIXI.utils.EventEmitter))) {
    override _name = 'dynamicBoxBorderConfigurator';
    override _classType = 'DynamicBoxBorderConfigurator';
    readonly graphicType = Config.BOX_BORDER_GRAPHIC;

    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_HEIGHT })
    private boxHeight = 'height';
    @StringOrNumberAttribute({ choices: Config.ALL_INFERRED_WIDTH })
    private boxWidth = 'width';
    @NumberAttribute()
    start0 = 0.25;
    @NumberAttribute()
    end0 = 0.75;
    @NumberAttribute()
    start1 = 0.75;
    @NumberAttribute()
    end1 = 0.25;
    @NumberAttribute({ animatable: false })
    horizontalPadding = 20;
    @NumberAttribute({ animatable: false })
    verticalPadding = 20;
    @NumberAttribute({ min: 0, animatable: false })
    borderThickness = 5;
    @ColorAttribute()
    borderColor = 0xFFFFFF;
    @AlphaAttribute()
    borderAlpha = 0.5;

    // eslint-disable-next-line no-useless-constructor
    constructor(settings) {
        super(settings);
    }

    /**
     * @inheritDoc
     */
    override get readonlyProperties() {
        return [];
    }

    /**
     * @inheritDoc
     */
    override get propertiesToSerialize() {
        return getAttributesToSerialize(this);
    };

    override get editableProperties() {
        return super.editableProperties.concat([
            'borderColor',
            'borderAlpha',
        ]);
    }
}
